import { Link } from 'react-router-dom';
import './App.css';

const Footer = () => {
  return (
    <footer className="App-footer">
      <div className="App-footer-content">
        <span>&copy; {new Date().getFullYear()} Nuvolem. All rights reserved.</span>
        <nav className="App-footer-links" aria-label="Legal">
          <Link className="text-link" to="/privacy">Privacy Policy</Link>
          <Link className="text-link" to="/terms">Terms of Service</Link>
        </nav>
        <a href='https://www.linkedin.com/company/nuvolem' aria-label="Nuvolem on LinkedIn" className="social-icon">
          <img src="/images/linkedin.svg" alt="LinkedIn" width="25" height="25" />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
